import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/home/Hero';
import About from '../components/home/About';
import Services from '../components/home/Services';
import Testimonials from '../components/home/Testimonials';
import Team from '../components/home/Team';
import FAQ from '../components/home/FAQ';
import Contact from '../components/home/Contact';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const el = document.getElementById(id);
    if (el) {
      requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="bg-white min-h-screen">
      <Hero />
      <section id="about"><About /></section>
      <section id="services"><Services /></section>
      <Testimonials />
      <Team />
      <FAQ />
      <section id="contact"><Contact /></section>
    </div>
  );
};

export default Home;
